import React from 'react';
export const GutHealthSection = () => {
  return <section id="gut-health" className="w-full py-12 bg-amber-50" data-id="element-136">
      <div className="container mx-auto px-4" data-id="element-137">
        <div className="flex flex-col md:flex-row items-center gap-8" data-id="element-138">
          <div className="w-full md:w-1/2" data-id="element-139">
            <h2 className="text-2xl md:text-3xl font-bold text-green-900 mb-4" data-id="element-140">
              How An Imbalanced Gut Affects Your Dog's ENTIRE Body
            </h2>
            <p className="text-green-900/80 mb-4" data-id="element-141">
              Before we talk about solutions, it's important to understand how
              gut health affects your dog's entire well-being.
            </p>
            <p className="text-green-900/80 mb-4" data-id="element-142">
              You see, your dog's gut isn't just about digestion. It contains
              70% of their immune system and produces 90% of their serotonin
              (the "happiness" chemical). When the gut is imbalanced – which
              happens to 85% of dogs fed modern kibble – it creates a cascade of
              problems throughout their entire body.
            </p>
            <p className="text-green-900/80 mb-6" data-id="element-143">
              This imbalance, which we call "Modern Diet Deficiency," occurs
              because today's processed dog food lacks the ancestral nutrients
              dogs evolved to thrive on. For thousands of years, dogs consumed
              organ meats, diverse proteins, and natural soil-based probiotics
              from their prey. Modern kibble has stripped all of this away.
            </p>
            <a href="#symptoms" className="bg-yellow-700 hover:bg-yellow-800 text-amber-50 font-bold py-3 px-8 rounded-full text-lg shadow-md transition duration-300 inline-block" data-id="element-144">
              CHECK THE CHECKLIST
            </a>
          </div>
          <div className="w-full md:w-1/2" data-id="element-145">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/ako87HMRaTmFUs1ythFmsN/ChatGPT_Image_20_de_jul._de_2025%2C_15_27_00.png" alt="Colorful visualization of dog gut microbiome with beneficial bacteria" className="rounded-lg w-full" data-id="element-146" />
          </div>
        </div>
      </div>
    </section>;
};